<template>
  <div>
    <navigation-bar v-if="!formOnly" />
    <div
      class="LOGIN  flex-column d-flex"
      v-bind:class="{ 'justify-content-center py-3': !formOnly }"
    >
      <div class="container">
        <div v-if="!formOnly" class="row justify-content-center mb-3">
          <a :href="config.tasracingWebsite">
            <img alt="" class="logo-link" src="/img/FormPlusProLogo.png" />
          </a>
        </div>

        <div class="row justify-content-center">
          <div
            v-bind:class="{ 'col-lg-4 col-md-6 col-sm-8 col-11': !formOnly }"
          >
            <!--Email and password signin-->
            <div
              class="box bg-dark p-4 text-center text-secondary br5"
              v-if="!resetPasswordRequired"
            >
              <h3 class="text-uppercase fw6 color-menu">Sign In</h3>
              <form @submit.prevent="handleSignIn" class="form-group m-0 mt-4">
                <label class="fw6 text-uppercase color-menu" for="email"
                  >EMAIL</label
                >
                <input
                  autocomplete="email"
                  class="form-control bg-dark1 br3 py-4 text-white border-0"
                  id="email"
                  required
                  type="email"
                  v-model="email"
                />
                <label class="fw6 text-uppercase mt-3 color-menu" for="password"
                  >password</label
                >
                <input
                  autocomplete="password"
                  class="form-control bg-dark1 br3 py-4 text-white border-0"
                  id="password"
                  required
                  type="password"
                  v-model="password"
                />
                <custom-button
                  :loading="loading || signingIn"
                  class="mb-3"
                  default-text="Sign in"
                  loading-text="Signing in"
                ></custom-button>

                <b-alert :show="errorMessage" variant="danger"
                  >{{ errorMessage }}
                  <a
                    @click.prevent="resend"
                    class="alert-link cursor-pointer "
                    v-if="resendConfirmation"
                    >Resend</a
                  >
                </b-alert>

                <b-alert :show="resendMessage" variant="dark"
                  >{{ resendMessage }}
                </b-alert>
              </form>
              <p class="m-0 mt-3">
                <router-link
                  :to="signupUrl"
                  class="text-secondary text-uppercase color-menu"
                  >Don't have an account? Sign up
                </router-link>
              </p>
              <p class="m-0 mt-3">
                <router-link
                  :to="forgotPwUrl"
                  class="text-secondary text-uppercase color-menu"
                  >Forgot your password?
                </router-link>
              </p>
              <img
                alt=""
                class="img-fluid d-block mx-auto my-4"
                src="img/or.png"
              />

              <button @click.prevent="facebookSignIn" class=" btn m-0 p-0">
                <img alt="" class="img-fluid" src="img/fb.png" />
              </button>
              <button @click.prevent="googleSignIn" class="btn mt-1 p-0">
                <img alt="" class="img-fluid" src="img/go.png" />
              </button>
              <a :href="twitterAuthUrl" class="btn mt-1 p-0">
                <img alt="" class="img-fluid" src="img/tw.png" />
              </a>
              <p class="m-0 mt-3">
                <a
                  href="mailto:FORMPLUS@tasracing.com.au"
                  class="text-secondary text-uppercase color-menu"
                  >Contact
                </a>
              </p>
            </div>

            <div class="box bg-dark p-4 text-center text-secondary br5" v-else>
              <h3 class="text-uppercase font-weight-bold mb-4">
                Reset Password
              </h3>
              <p>Please enter a new password to get started.</p>
              <form @submit.prevent="resetPassword" class="form-group m-0">
                <label
                  class="font-weight-bold text-uppercase mt-3"
                  for="password"
                  >new password</label
                >
                <input
                  :minlength="config.minPasswordLength"
                  autocomplete="password"
                  class="form-control bg-dark1 br3 py-4 text-white border-0"
                  id="password-reset"
                  required
                  type="password"
                  v-model="newPassword"
                />
                <custom-button
                  :loading="resettingPassword"
                  class="mb-3"
                  default-text="Reset Password"
                  loading-text="Resetting Password"
                ></custom-button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Auth } from "aws-amplify";
import { GetMeAndHandleRedirect, setRedirectUrl } from "@/commons";
import CustomButton from "@/components/commons/CustomButton";
import config from "@/config";
import NavigationBar from "../commons/NavigationBar";

export default {
  name: "Login",
  components: { NavigationBar, CustomButton },
  props: {
    formOnly: {
      default: false,
      type: Boolean,
    },
  },
  data() {
    return {
      email: "",
      password: "",
      newPassword: "",
      errorMessage: null,
      resendMessage: null,
      loading: false,
      resendConfirmation: false,
      resetPasswordRequired: false,
      resettingPassword: false,
      userChallenge: null,
    };
  },

  async mounted() {
    const query = this.$route.query;
    if (query && query.redirect) {
      setRedirectUrl(query.redirect);
    }

    if (query && query.error_description) {
      let errorDesc = query.error_description;
      errorDesc = errorDesc.replace("PreSignUp failed with error", "");
      errorDesc = errorDesc.replace(
        "PreSignUp invocation failed due to error",
        ""
      );
      errorDesc = errorDesc.replace("PreAuthentication failed with error", "");
      this.errorMessage = errorDesc;
    }

    GetMeAndHandleRedirect();
  },
  methods: {
    async resetPassword() {
      this.resettingPassword = true;
      try {
        await Auth.completeNewPassword(
          this.userChallenge,
          this.newPassword,
          {}
        );
      } catch (e) {
        console.log("Error while resetting password", e.message);
      }
      this.resettingPassword = false;
    },
    handleSignInFormDataChange() {
      if (this.email || this.password) this.errorMessage = null;
    },
    facebookSignIn() {
      Auth.federatedSignIn({ provider: "Facebook" });
    },
    googleSignIn() {
      Auth.federatedSignIn({ provider: "Google" });
    },
    async resend() {
      this.resendMessage = null;
      try {
        const result = await Auth.resendSignUp(this.email);
        const { AttributeName, Destination } = result.CodeDeliveryDetails;
        this.resendMessage = `${AttributeName} sent to ${Destination}`;
      } catch (err) {
        this.resendMessage = err.message;
      }
    },
    handleSignIn: async function() {
      this.errorMessage = null;
      this.loading = true;
      this.resendConfirmation = false;
      this.resetPasswordRequired = false;

      try {
        const user = await Auth.signIn(this.email.toLowerCase(), this.password);

        if (
          user.challengeName === "SMS_MFA" ||
          user.challengeName === "SOFTWARE_TOKEN_MFA"
        ) {
          console.log("MFA required");
        } else if (user.challengeName === "NEW_PASSWORD_REQUIRED") {
          this.resetPasswordRequired = true;
          this.userChallenge = user;
          console.log("need to change password");
          /*const {requiredAttributes} = user.challengeParam; // the array of required attributes, e.g ['email', 'phone_number']
                        const {username, email, phone_number} = getInfoFromUserInput();
                        const loggedUser = await Auth.completeNewPassword(
                            user,              // the Cognito User Object
                            newPassword,       // the new password
                            // OPTIONAL, the required attributes
                            {
                                email,
                                phone_number,
                            }
                        );*/
        } else if (user.challengeName === "MFA_SETUP") {
          console.log("need to setup mfa");
        } else {
          // Successful login
        }
      } catch (err) {
        this.errorMessage = err?.message;
        if (err.code === "UserNotConfirmedException") {
          this.resendConfirmation = true;
          this.errorMessage = `Please activate your account by  clicking the VERIFY ACCOUNT button in the verification email sent to this address.`;
        } else if (err.code === "NotAuthorizedException") {
        } else if (err.code === "PasswordResetRequiredException") {
          setTimeout(() => this.$router.push(this.forgotPwUrl), 750);
        } else {
          this.errorMessage = err?.message?.replace(
            "PreAuthentication failed with error",
            ""
          );
        }
      }
      this.loading = false;
    },
  },
  computed: {
    signupUrl() {
      return `/signup${
        this.originatingSite ? "?redirect=" + this.originatingSite : ""
      }`;
    },
    forgotPwUrl() {
      return `/forgot-pw${this.email ? "?email=" + this.email : ""}`;
    },
    initialNotificationPreferenceUrl() {
      return "/initial-notification-settings";
    },
    userInfo() {
      return this.$store.state.user;
    },
    twitterAuthUrl() {
      const url = config.twitterAuthUrl;
      return `${url}?redirect=${window.location.href}`;
    },
    config() {
      return config;
    },
    signingIn() {
      return this.$store.state.signingIn;
    },
  },
};
</script>

<style scoped>
.logo-link {
  width: 200px !important;
}
</style>
